var _style, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F24535;}\r\n\t.st1{fill:#F24535;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M247.5,294.8h-64.5c-10,16.9-27.6,28.5-49.8,28.5c-35.1,0-58.6-28.2-58.6-61.4v-0.6c0-33.2,23.8-62,59.2-62 c21.9,0,39.2,11,48.9,27.6h65.2h2.5v-6.3c-16.6-46-61.4-78.9-116.8-78.9C62.7,141.6,10,194.5,10,260.3v0.6 c0,66.1,53.3,119.4,124.1,119.4c55.4,0,99.6-32.3,116.2-78v-7.5H247.5z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M366.5,380.3c70.8,0.3,124.1-53.3,124.1-119v-0.6c0-66.1-52.3-119-123.4-119c-55.4,0-100.2,32.9-116.8,78.9v6.3 h1.9h65.2c9.7-16.6,27.3-27.6,48.9-27.6c35.1,0,59.2,28.8,59.2,62v0.6h0.3c0,33.2-23.2,61.4-58.6,61.4c-21.9,0-39.8-11.6-49.8-28.5 h-64.5h-2.5v7.5c0,0,0,0,0,0C266.9,348,311.1,380.3,366.5,380.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.7e229c0f514b380a7979ebcc733a786f.svg";
export { ForwardRef as ReactComponent };